export const STRUCTURAL_FILE_TYPES = new Set(['csv', 'xlsx', 'xls', 'txt'])

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${(bytes / k ** i).toFixed(1)} ${sizes[i]}`
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'processed':
    case 'indexed':
      return 'bg-success-surface text-success-foreground border-success-border'
    case 'processing':
      return 'bg-info-surface text-info-foreground border-info-border'
    case 'uploaded':
    case 'pending':
    case 'skipped':
      return 'bg-muted text-muted-foreground/70 border-border dark:bg-border dark:text-muted-foreground dark:border-border'
    case 'failed':
      return 'bg-destructive-surface text-destructive-foreground border-destructive-border'
    default:
      return 'bg-muted text-muted-foreground/70 border-border dark:bg-border dark:text-muted-foreground dark:border-border'
  }
}
